const DEFAULT_MAX_SIDE = 512;
const JPEG_QUALITY = 0.88;

/**
 * Lê um arquivo de imagem, redimensiona mantendo proporção (lado máximo `maxSide`)
 * e devolve JPEG em data URL (base64), adequado para envio em JSON.
 */
export function resizeImageFileToJpegDataUrl(
  file: File,
  maxSide: number = DEFAULT_MAX_SIDE
): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) {
      reject(new Error("Arquivo não é uma imagem."));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      if (typeof dataUrl !== "string") {
        reject(new Error("Não foi possível ler a imagem."));
        return;
      }
      const img = new Image();
      img.onload = () => {
        const { width, height } = img;
        if (!width || !height) {
          reject(new Error("Dimensões da imagem inválidas."));
          return;
        }
        const scale = Math.min(maxSide / width, maxSide / height, 1);
        const w = Math.max(1, Math.round(width * scale));
        const h = Math.max(1, Math.round(height * scale));
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("Navegador não suporta edição de imagem."));
          return;
        }
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", JPEG_QUALITY));
      };
      img.onerror = () => reject(new Error("Não foi possível carregar a imagem."));
      img.src = dataUrl;
    };
    reader.onerror = () => reject(reader.error ?? new Error("Falha ao ler o arquivo."));
    reader.readAsDataURL(file);
  });
}
